import { RelatedID } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/models.pb';

export type RelatedIDWithRequirement = RelatedID & { requiredString?: string };

export const getRelatedIdsThatMeetRequirements = ({
  relatedIds,
  body,
}: {
  relatedIds: RelatedIDWithRequirement[];
  body: string;
}): RelatedID[] => {
  return relatedIds.reduce<RelatedID[]>((acc, { requiredString, ...curr }) => {
    if (!requiredString || body.includes(requiredString)) acc.push(curr);
    return acc;
  }, []);
};
